import { Controller } from "@hotwired/stimulus"
import { Calendar } from "fullcalendar"
import interactionPlugin from "fullcalendar/interaction"
import timeGridPlugin from "fullcalendar/timegrid"
import themePlugin from "fullcalendar/themes/classic"

export default class extends Controller {
  static targets = ["enabled", "settings", "input", "calendar", "windows"]

  connect() {
    this.windows = JSON.parse(this.inputTarget.value || "[]")
    this.calendar = new Calendar(this.calendarTarget, {
      plugins: [themePlugin, interactionPlugin, timeGridPlugin],
      initialView: "timeGridWeek",
      initialDate: "2026-01-05",
      firstDay: 1,
      headerToolbar: false,
      dayHeaderFormat: { weekday: "long" },
      eventTimeFormat: { hour: "numeric", minute: "2-digit", meridiem: "short" },
      allDaySlot: false,
      nowIndicator: false,
      height: "auto",
      selectable: true,
      selectLongPressDelay: 250,
      // FullCalendar 7 RC miscalculates drag hits when snapDuration differs from slotDuration.
      slotDuration: "00:15:00",
      slotLabelInterval: "01:00:00",
      snapDuration: "00:15:00",
      selectAllow: (info) => info.end <= new Date(info.start.getFullYear(), info.start.getMonth(), info.start.getDate() + 1),
      select: (info) => {
        this.windows.push({ weekday: info.start.getDay(), start_minute: this.minutes(info.start),
          end_minute: info.end.getDate() !== info.start.getDate() ? 1440 : this.minutes(info.end) })
        this.sync()
        this.calendar.unselect()
      },
      eventClick: (info) => this.remove(Number(info.event.id))
    })
    this.calendar.render()
    this.sync()
    this.toggle()
  }

  disconnect() { this.calendar?.destroy() }

  toggle() {
    this.settingsTarget.hidden = !this.enabledTarget.checked
    if (this.enabledTarget.checked) this.calendar?.updateSize()
  }

  minutes(date) { return date.getHours() * 60 + date.getMinutes() }
  time(minutes) { return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}` }
  displayTime(minutes) {
    const hour = Math.floor(minutes / 60) % 24
    return `${hour % 12 || 12}:${String(minutes % 60).padStart(2, "0")}${hour < 12 ? "am" : "pm"}`
  }

  allDay(event) {
    const day = Number(event.currentTarget.dataset.weekday)
    this.windows = this.windows.filter((window) => window.weekday !== day)
    this.windows.push({ weekday: day, start_minute: 0, end_minute: 1440 })
    this.sync()
  }

  clear() { this.windows = []; this.sync() }
  remove(index) { this.windows.splice(index, 1); this.sync() }

  sync() {
    this.inputTarget.value = JSON.stringify(this.windows)
    this.calendar.removeAllEvents()
    this.calendar.addEventSource(this.windows.map((window, index) => ({
      id: String(index), title: "Available", daysOfWeek: [window.weekday],
      startTime: this.time(window.start_minute), endTime: this.time(window.end_minute)
    })))
    this.windowsTarget.replaceChildren()
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    this.windows.forEach((window, index) => {
      const item = document.createElement("li")
      item.textContent = `${days[window.weekday]} ${this.displayTime(window.start_minute)}–${this.displayTime(window.end_minute)} `
      const button = document.createElement("button")
      button.type = "button"
      button.className = "underline font-semibold"
      button.textContent = "Remove"
      button.setAttribute("aria-label", `Remove ${item.textContent.trim()}`)
      button.addEventListener("click", () => this.remove(index))
      item.append(button)
      this.windowsTarget.append(item)
    })
  }
}
